import { validationMessage } from 'vuelidate-messages'
import { messages, validationPass } from '@/lib/validation-helpers'
import { required, maxLength } from 'vuelidate/lib/validators'

export const validations = {
  validations: {
    formData: {
      publisher_id: {
        required
      },
      platform: {
        maxLength: maxLength(255)
      },
      name: {
        required,
        maxLength: maxLength(255)
      },
      online_identifier: {
        maxLength: maxLength(20)
      },
      print_identifier: {
        maxLength: maxLength(20)
      }
    }
  },

  methods: {
    $v_displayMessage: validationMessage(messages),
    $v_validationPass: validationPass
  }
}
